module.exports = __webpack_public_path__ + "static/pic01-172407234a9d16c790179108749a91f6.svg";